module.exports = __webpack_public_path__ + "img/cardBg.eb75b67a.png";